import { css } from "@emotion/react";
import React, { ReactNode, useState } from "react";
import { pxToRem, weights, mediaQueries, fonts, fontSizeLineHeight } from "../utils/css-utils";
import { colors } from "../utils/colors";

type AnnouncementProps = {
  text: string,
  linkText: string,
  href: string,
  color?: string,
  icon?: any,
  closed?: boolean,
  id?: string,
};

const Announcement: React.FC<AnnouncementProps> = ({ text, linkText, href, color, icon, closed, id, ...props }) => {
  let bgColor,
      textColor;

  switch (color) {
    case 'lime':
      bgColor = colors.lime600;
      textColor = colors.neutral800;
      break;
    case 'violet':
    default:
      bgColor = colors.violet600;
      textColor = colors.white;
      break;
  }

  const announcementId = id ? id : 'announceDefault';

  const announcementWrapperStyles = css`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: ${pxToRem(12)} ${pxToRem(32)};
    text-align: center;
    ${fontSizeLineHeight(16,24)};
    color: ${textColor};
    background: ${bgColor};
    font-family: ${fonts.sans};
    font-weight: ${weights.regular};

    ${mediaQueries.md} {
      padding: ${pxToRem(16)} ${pxToRem(32)};
    }

    ${mediaQueries.xl} {
      ${fontSizeLineHeight(18,32)};
    }
  `;

  const linkStyles = css`
    color: inherit;
  `;

  const closeStyles = css`
    position: absolute;
    top: 0;
    right: 0;
    width: ${pxToRem(40)};
    height: ${pxToRem(40)};
    border: none;
    background: transparent;
    cursor: pointer;
    appearance: none;

    ${mediaQueries.md} {
      top: 50%;
      right: ${pxToRem(14)};
      transform: translateY(${pxToRem(-20)});
    }
  `;

  const xStyles = css`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(66%);

    ${mediaQueries.md} {
      transform: translate(-50%, -50%);
    }

    path {
      fill: ${textColor};
    }
  `;

  const iconStyles = css`
    display: block;
    position: relative;
    width: ${pxToRem(24)};
    height: ${pxToRem(24)};
    margin: 0 auto ${pxToRem(8)};


    ${mediaQueries.md} {
      display: inline;
      margin: 0;
      padding-right: ${pxToRem(8)};
    }

    svg {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: ${pxToRem(24)};
      height: auto;

      ${mediaQueries.md} {
        right: ${pxToRem(8)};
        left: auto;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  `;

  const [isClosed, setisClosed] = useState(closed);

  const closeAnnouncement = (aid) => {
    setisClosed(true);
    sessionStorage.setItem("upsun_hide_announce", aid);
  }

  if (isClosed) {
    return null;
  }
  else {
    return (
      <div css={announcementWrapperStyles} {...props} id={announcementId}>
        <button css={closeStyles} onClick={() => closeAnnouncement(announcementId)} aria-controls={announcementId} aria-label="Close">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" css={xStyles}>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M17.7046 6.29537C17.3108 5.90154 16.6723 5.90154 16.2785 6.29537L12 10.5738L7.72153 6.29537C7.3277 5.90154 6.68919 5.90154 6.29537 6.29537C5.90154 6.68919 5.90154 7.3277 6.29537 7.72153L10.5738 12L6.29537 16.2785C5.90154 16.6723 5.90154 17.3108 6.29537 17.7046C6.68919 18.0985 7.3277 18.0985 7.72153 17.7046L12 13.4262L16.2785 17.7046C16.6723 18.0985 17.3108 18.0985 17.7046 17.7046C18.0985 17.3108 18.0985 16.6723 17.7046 16.2785L13.4262 12L17.7046 7.72153C18.0985 7.3277 18.0985 6.68919 17.7046 6.29537Z" fill="#2B3200"/>
          </svg>
        </button>
        <div>
          {icon && <span css={iconStyles}>{icon}</span>}
          <span dangerouslySetInnerHTML={{__html: text}} />
          {' '}
          <a href={href} css={linkStyles}>{linkText}</a>
        </div>
      </div>
    )
  }
 
};

export default Announcement;
